import "./TfStoreViewComponent.scss";
import {IComponentOptions, IScope} from "angular";
import {TfStoreViewStore} from "../services/TfStoreViewStore";
import {TfStoreService} from "../services/TfStoreService";
import {CurrentUserService} from "../../../services/user/CurrentUserService";
import {StateService} from "@uirouter/core";
import {StoreStateParams} from "../../common/models/StoreStateParams";
import {StoreController} from "../../common/controllers/StoreController";
import {TfProductMappings, TfStoreProduct} from "../models/TfStoreProduct";

export const TfStoreView = "tfStoreView";

export function tfStoreView(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/view/TfStoreViewComponent.html`,
        bindings: {
            viewStore: "<"
        },
        controllerAs: "ctrl",
        controller: TfStoreViewComponentController
    };
}

export class TfStoreViewComponentController extends StoreController<TfStoreProduct> {

    public viewStore: TfStoreViewStore;
    protected billingInterval(): "MONTH" | "YEAR" {
        return this.viewStore.billingCycle || "MONTH";
    }

    /** @ngInject */
    public constructor($scope: IScope,
                       tfStoreService: TfStoreService,
                       currentUserService: CurrentUserService,
                       $stateParams: StoreStateParams<TfStoreProduct>,
                       $state: StateService,
                       simpleModalService: any) {
        super($scope, tfStoreService, currentUserService, $stateParams, $state, TfProductMappings, simpleModalService);
    }
}
